import { useQuery } from "@tanstack/react-query";
import { GET_NEXT_STEPS_DEBUG } from "../api/queries";
import { graphQLClient } from "../graphqlClient";
import { useReactQueryErrorReporter } from "./use-error-reporter";
import { useCurrentUser } from "./useCurrentUser";
import { useProductFeatures } from "./useProductFeatures";

export const useNextStepsDebug = () => {
  const currentUser = useCurrentUser();
  const userPath = currentUser?.userPath;
  const { productPlans } = useProductFeatures();
  console.info("currentUser", currentUser);

  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["nextStepsDebug", userPath, productPlans],
    queryFn: () => {
      return graphQLClient.request(GET_NEXT_STEPS_DEBUG, {
        userPath,
        productPlans: productPlans || [],
      });
    },
    enabled: !!userPath,
    staleTime: 0, // Consider data fresh for 5 minutes
  });

  useReactQueryErrorReporter("Could not load next steps debug data", error);

  return {
    nextStepsDebugData: data?.getNextStepsDebug,
    loading: isLoading,
    error,
    refetch,
  };
};
